<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-primary">
            </div>
        </section>
        <section class="section pt-5 pb-5">
            <div class="container container-lg">
                <div class="row">
                    <div class="col-lg-4">
                        <profile-navigation :name="firstName"></profile-navigation>
                    </div>
                    <div class="col-lg-8">
                        <div class="d-md-flex justify-content-between align-items-center">
                            <h4>{{sectionTitle}}</h4>
                        </div>
                        <form role="form" @submit.prevent method="get" :disabled="$wait.is('profile.add.address')">
                            <div class="row">
                                <div class="col-12">
                                    <base-input alternative
                                        class="mb-3"
                                        id="nome"
                                        :valid="formerrors.nome"
                                        v-model="newAddress.nome"
                                        placeholder="Dê um nome para o Endereço (ex.: casa, escritório)"
                                        >
                                    </base-input>
                                    <base-input alternative
                                        class="mb-3"
                                        id="cep"
                                        type="tel"
                                        required
                                        pattern="[0-9]{5}-[0-9]{3}"
                                        v-model="newAddress.cep"
                                        placeholder="CEP"
                                        :valid="formerrors.cep"
                                        v-mask="'#####-###'"
                                        >
                                    </base-input>
                                    <base-input alternative
                                        class="mb-3"
                                        id="endereco"
                                        v-model="newAddress.endereco"
                                        placeholder="Logradouro"
                                        :valid="formerrors.endereco"
                                        >
                                    </base-input>
                                </div>
                                <div class="col-6">
                                    <base-input alternative
                                        class="mb-3"
                                        type="tel"
                                        pattern="[0-9]{1,}"
                                        id="numero"
                                        v-model="newAddress.numero"
                                        placeholder="Número"
                                        :valid="formerrors.numero"
                                        >
                                    </base-input>
                                </div>
                                <div class="col-6">
                                    <base-input alternative
                                        class="mb-3"
                                        id="complemento"
                                        v-model="newAddress.complemento"
                                        placeholder="Complemento"
                                        >
                                    </base-input>
                                </div>
                                <div class="col-12">
                                    <base-input alternative
                                        class="mb-3"
                                        id="bairro"
                                        v-model="newAddress.bairro"
                                        placeholder="Bairro"
                                        >
                                    </base-input>
                                    <base-input alternative
                                        class="mb-3"
                                        id="cidade"
                                        v-model="newAddress.cidade"
                                        placeholder="Cidade"
                                        :valid="formerrors.cidade"
                                        >
                                    </base-input>
                                    <v-select
                                        class="form-group input-group-alternative mt-3"
                                        :class="{'error': formerrors.uf == false}"
                                        v-on:input="newAddress.uf = $event"
                                        :value="newAddress.uf"
                                        :key="newAddress.uf"
                                        placeholder="Estado"
                                        :options="estados"
                                        :reduce="estado => estado.code"
                                        />
                                    <base-input alternative
                                        class="mb-3"
                                        id="ponto_referencia"
                                        v-model="newAddress.ponto_referencia"
                                        placeholder="Ponto de Referência"
                                        >
                                    </base-input>
                                </div>
                                <div class="col-12">
                                    <base-button type="primary" @click="$router.back()" class="mt-4 d-inline-block float-left">Voltar</base-button>
                                    <base-button nativeType="submit" @click="putAddress()" type="success" class="mt-4 d-inline-block float-right">{{sectionButton}}</base-button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { SlideYUpTransition } from "vue2-transitions";

import vSelect from 'vue-select';

import ProfileNavigation from './components/ProfileNavigation.vue';

import EstadosBrasileiros from '@/settings/estados.json';

import {mask} from 'vue-the-mask';

export default {
	name: 'profile-address-put',
    directives: {mask},
    components: {
        ProfileNavigation,
        SlideYUpTransition,
        vSelect,
    },
    data() {
    return {
      newAddress: {},
      formerrors: {},
      estados: EstadosBrasileiros,
      };
    },
    computed: {
        firstName: function() {
            return this.$store.state.auth.first_name
        },
        sectionTitle: function() {
            return ( !this.newAddress.id ) ? 'Novo Endereço' : 'Editar Endereço';
        },
        sectionButton: function() {
            return ( !this.newAddress.id ) ? 'Cadastrar' : 'Salvar';
        },
        addressID() {
            return this.$route.params.id || null;
        },
    },
    methods: {
        putAddress(){
            const payload = this.newAddress;
            this.formerrors = {};
            this.$wait.start('profile.post.address');
            if ( payload.id ) {
                let _id = payload.id;
                this.axios.patch('/v1/address/'+_id+'/', payload)
                .then(response => {
                })
                .catch(e => {
                  let errors = e.data;
                  Object.keys(errors).forEach(key => {
                    this.formerrors[key] = false;
                  });
                }).then(response =>{
                    this.$wait.end('profile.post.address');
                    this.$router.push('/perfil/enderecos');
                });
            } else {
                this.axios.post('/v1/address/', payload)
                .then(response => {
                })
                .catch(e => {
                  let errors = e.data;
                  Object.keys(errors).forEach(key => {
                    this.formerrors[key] = false;
                  });
                }).then(response =>{
                    this.$wait.end('profile.post.address');
                    this.$router.push('/perfil/enderecos');
                });
            }
        },
    },
    created() {
        if ( this.addressID !== null ) {
            this.$wait.start('profile.load.address');
            this.axios.get('/v1/address/'+this.addressID)
            .catch(e => {
                this.$wait.end('profile.load.address');
                this.$router.push('/perfil/enderecos');
            }).then(response => {
              this.newAddress = response.data;
              this.formerrors = {};
              this.$wait.end('profile.load.address');
            });
        }else {
            this.newAddress = {};
            this.formerrors = {};
        }
        //
    }
};
</script>

<style lang="scss">
    .address-line {
        p {
            margin-bottom: 0;
            font-size: 0.9em;
            line-height: 1.4;
            strong {
                font-weight: 700;
            }
        }
    } 
</style>
